import * as ng from 'angular';

export const UibDatepickerPopup = (
    uibDateParser,
    uibDatepickerPopupConfig
) => (<angular.IDirective>{

    restrict: 'A',

    priority: 1,

    require: 'ngModel',

    link: (scope: any, elem: JQLite, attr: any, ngModel: ng.INgModelController) => {
        let dateFormat = attr.uibDatepickerPopup || uibDatepickerPopupConfig.datepickerPopup;
        ngModel.$validators.date = (modelValue, viewValue) => {
            let value = viewValue || modelValue;
            if (!attr.ngRequired && !value) {
                return true;
            }

            if (ng.isNumber(value)) {
                value = new Date(value);
            }
            if (!value) {
                return true;
            } else if (ng.isDate(value) && !isNaN(Number(value))) {
                return true;
            } else if (ng.isString(value)) {
                let date = uibDateParser.parse(value, dateFormat);
                return !isNaN(date);
            } else {
                return false;
            }
        };
    }
});




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/uib-datepicker-popup/uib-datepicker-popup.directive.ts